import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {SharingRulesGroup} from '../api/entity/sharing-rules-group.model';
import {isNullOrUndefined} from 'util';
import {DictionaryObject} from '../../../../../common/api';
import {TranslateManager} from '../../../../../common/translate';
import {ExceptionTypeService} from '../exception-type.service';
import {ControlContainer, NgModelGroup} from '@angular/forms';
import {UniqueIdGenerator} from './unique-id-generator.service';
import {EXCEPTION_TYPE} from './entities/exception-type.model';
import {ConditionsSelectorComponent} from './conditions/conditions-selector.component';

@Component({
    selector: 'tfl-revenue-distribution-exception',
    template: require('./revenue-distribution.exception.component.html'),
    viewProviders: [{provide: ControlContainer, useExisting: NgModelGroup}]
})

export class RevenueDistributionExceptionComponent implements OnInit {

    @Input() model: SharingRulesGroup;
    @Input() index: number;
    @Input('profile-id') profileId: number;
    @Input() availableFeeServices: DictionaryObject[];
    @Input('available-profiles') availableProfiles: DictionaryObject[];
    @Input('available-profile-kinds') availableProfileKinds: any;
    @Input('collapsed') isCollapsed = false;

    @Output() conditionsChanged = new EventEmitter();
    @Output() removed = new EventEmitter();

    @ViewChild(ConditionsSelectorComponent) itemsSelector: ConditionsSelectorComponent;
    @ViewChild(NgModelGroup) group: NgModelGroup;

    private _formGroupId: string;
    exceptionType: string;

    constructor(private _translationService: TranslateManager,
                private _exceptionTypeService: ExceptionTypeService,
                private _idGenerator: UniqueIdGenerator) {
    }

    ngOnInit(): void {
        this.exceptionType = this.resolveExceptionType();
    }

    get formGroupId(): string {
        if (this._formGroupId) {
            return this._formGroupId;
        }
        this._formGroupId = isNullOrUndefined(this.model.id) ? this._idGenerator.generate()
            : String(this.model.id);
        return this._formGroupId;
    }

    get availableConditions(): DictionaryObject[] {
        switch (this.exceptionType) {
            case EXCEPTION_TYPE.FOR_PROFILE_KINDS:
                return this.availableProfileKinds;
            case EXCEPTION_TYPE.FOR_PROFILES:
                return this.availableProfiles;
        }
    }

    get selectedConditions(): DictionaryObject[] {
        switch (this.exceptionType) {
            case EXCEPTION_TYPE.FOR_PROFILES:
                return this.model.conditions.profiles;
            case EXCEPTION_TYPE.FOR_PROFILE_KINDS:
                return this.model.conditions.profileKinds;
        }
    }

    onRemoved() {
        this.itemsSelector.deselectAll();//free up shared pool of available items
        this.removed.next(this.index);
    }

    isSelectorValid() {
        if (this.group.control) {
            const selector = this.group.control.get('editConditions-' + this.formGroupId);
            if (selector) {
                return selector.valid || !selector.dirty;
            }
        }
        return true;
    }

    onConditionSelected(condition) {
        if (this.selectedConditions.findIndex((it) => it.id == condition.id) < 0) {
            this.selectedConditions.push(condition);
        }
        this.notifyParentComponentOfChanges();
    }

    private notifyParentComponentOfChanges() {
        setTimeout(() =>
            {
                let available = !isNullOrUndefined(this.availableConditions)
                    && this.availableConditions.length > 0;
                this._exceptionTypeService.updateAvailability(this.exceptionType, available);
            }
        );
        this.conditionsChanged.next();
    }

    onConditionDeselected(condition) {
        let i = this.selectedConditions.findIndex(p => p.id == condition.id);
        this.selectedConditions.splice(i, 1);
        this.notifyParentComponentOfChanges();
    }

    get availableConditionsName(): string {
        switch (this.exceptionType) {
            case EXCEPTION_TYPE.FOR_PROFILES:
                return this._translationService.getValue('CUSTOMER.DETAILS.TAB.SETTINGS.USERS');
            case EXCEPTION_TYPE.FOR_PROFILE_KINDS:
                return this._translationService.getValue('CUSTOMER.DETAILS.TAB.SETTINGS.TYPES_OF_USERS');
        }
    }

    private resolveExceptionType(): string {
        if (this.model.conditions.type) {//we know condition type when creating condition explicitly
            return this.model.conditions.type;
        }
        if (this.conditionIsPresent(this.model.conditions.profiles)) { //we do not know condition type when showing conditions retrieved from API
            return EXCEPTION_TYPE.FOR_PROFILES;
        }
        if (this.conditionIsPresent(this.model.conditions.profileKinds)) {
            return EXCEPTION_TYPE.FOR_PROFILE_KINDS;
        }
        return undefined;
    }

    private conditionIsPresent(condition: any[]): boolean {
        return (!isNullOrUndefined(condition)) && condition.length > 0;
    }

    onCollapse() {
        this.isCollapsed = !this.isCollapsed;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/revenue/exceptions/revenue-distribution.exception.component.ts